import { apiService } from "../../core/api";
import { API_ENDPOINTS } from "../../core/constants/endpoints";
import { NotificationsApiResponse } from "./types";

export class NotificationsService {
  async getAllNotifications(): Promise<NotificationsApiResponse> {
    // Return mock data for now, later replace with:
    return apiService.get<NotificationsApiResponse>(
      API_ENDPOINTS.NOTIFICATIONS.GET_ALL
    );
    // return Promise.resolve(mockResponse);
  }

  async markAsRead(notificationId: string): Promise<void> {
    return apiService.post(API_ENDPOINTS.NOTIFICATIONS.READ, {
      notification_id: notificationId,
    });
  }
}

export const notificationsService = new NotificationsService();
